//A comonent that recieves a list of activity items
// it first creates a dictionary based on the date
// then renders them in a list for each date

import React from 'react';
import styled from 'styled-components';
import ActivityListItemComponent from "./ActivityItemComponent";

const HeadSpan = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    letter-spacing: 0.1px;
    color: #7A7F9E;

`
const ActivityListComponent = (props:any)=> {

    const [activityListDict, setActivityListDict] = React.useState({} as any);
    React.useEffect(()=>{
        //sort and create dictionary based on date
        let dict:any = {};
        props.activityItems.forEach((item:any)=>{
            let date = new Date(item.metadata.blockTimestamp);
            let key = date.toDateString();
            let now = new Date();
            if(date.toDateString() === now.toDateString()){
                key = "Today";
            }
            if(dict[key]){
                dict[key].push(item);
            }else{
                dict[key] = [item];
            }
        });
        setActivityListDict(dict);
        // console.log(props.activityList)
    },[props.activityList])


    //render a dict of lists
    // but first render the key which is the date
    return (
        <>
          {Object.keys(activityListDict).map((key:any, index:number)=>{
              return (
                  <div key={key} style={{marginTop:index===0?0: 20}}>
                    <HeadSpan >{key}</HeadSpan>
                    <>
                      {activityListDict[key].map((item:any)=>{
                          return (
                              <ActivityListItemComponent key={item.id} item={item}/>)
                      })}
                    </>
                  </div>
              )
          })}
        </>
    )
}
export default ActivityListComponent;
